export default {
  buttonSmall: {
    fontSize: '13px',
    lineHeight: '22px',
  },
  buttonMedium: {
    fontSize: '14px',
    lineHeight: '24px',
  },
  buttonLarge: {
    fontSize: '15px',
    lineHeight: '26px',
  },
}
